import { useId, type ComponentProps } from "react";
import { cn } from "@volca/ui/lib/utils";

const CELL = 28;

const MASK = [
  "linear-gradient(to right, transparent, black 14%, black 86%, transparent)",
  "linear-gradient(to bottom, transparent, black 14%, black 42%, transparent 70%)",
].join(", ");

const Family = ({ id, angle }: { id: string; angle: number }) => (
  <pattern
    id={id}
    width={CELL}
    height={CELL}
    patternUnits="userSpaceOnUse"
    patternTransform={`rotate(${angle - 90})`}
  >
    <line x1={0} y1={0} x2={0} y2={CELL} className="stroke-line" />
  </pattern>
);

export const FloorGrid = ({
  floor,
  className,
  ...props
}: {
  floor: [number, number];
} & ComponentProps<"svg">) => {
  const id = useId();
  return (
    <svg
      {...props}
      aria-hidden
      focusable={false}
      className={cn(
        "pointer-events-none absolute inset-0 size-full",
        className,
      )}
      style={{
        maskImage: MASK,
        WebkitMaskImage: MASK,
        maskComposite: "intersect",
        WebkitMaskComposite: "source-in",
      }}
    >
      <defs>
        <Family id={`${id}-x`} angle={floor[0]} />
        <Family id={`${id}-y`} angle={floor[1]} />
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id}-x)`} />
      <rect width="100%" height="100%" fill={`url(#${id}-y)`} />
    </svg>
  );
};
